<template>
  <select
    :name="name"
    :value="value"
    @change="updateValue($event.target.value)"
  >
    <option
      v-for="(option, index) in options"
      :key="index"
      :value="option.value"
      :selected="isTarget(option.value)"
      >{{ option.name }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    isTarget(value) {
      return this.value === value
    },
    updateValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>
